import React from 'react';
import {editCompanyConvVis} from "../../../../../../../../services/company/api";
import Translate, {t} from "../../../../../../../../components/Translate";
import ChoiceButtons from "../../../../../../../../components-new/form/ChoiceButtons";
import SettingCard from "../../../../../../../../components-new/ui/SettingCard";

/**
 * @param disabled auto-connect is on, which assigns chats by itself and leaves
 *   this setting with nothing to do. The card says so rather than staying silent
 *   and merely greying out.
 */
const ConversationVisibilityConfig = ({features, client, user, convVis, setConvVis, disabled, isFetching}) => {

    const options = [
        {value: 'ALL', label: t({text: "all", user})},
        {value: 'BY_SKILLS', label: t({text: "bySkills", user})},
        {value: 'DISABLED', label: t({text: "DISABLED", user})}
    ];

    const handleChange = (value) => {
        setConvVis({...convVis, type: value});
        editCompanyConvVis(client.id, value);
    };

    return (
        <SettingCard titleKey="convVisHeader" dimmed={disabled}>
            {/* only while it is actually true: the condition used to live in the
                heading, where it was stated even when auto-connect was off */}
            {disabled && (
                <p className="setting-notice">
                    <Translate text="convVisIgnoredByAutoConnect"/>
                </p>
            )}

            <div
                className={'setting-body' + (disabled ? ' setting-body--off' : '')}
                style={{opacity: isFetching ? 0.5 : 1}}
            >
                <div className="setting-field">
                    <ChoiceButtons
                        value={convVis.type || 'ALL'}
                        options={options}
                        onChange={handleChange}
                        disabled={disabled || isFetching}
                    />
                </div>
            </div>
        </SettingCard>
    );
};

export default ConversationVisibilityConfig;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/components/ConversationVisibilityConfig.jsx